// extracted by mini-css-extract-plugin
module.exports = {"MetaMask":"MetaMask_MetaMask__1CfXv","MetaMaskButtonLink":"MetaMask_MetaMaskButtonLink__KT2dZ","MetaMaskImg":"MetaMask_MetaMaskImg__2FTeT"};